import 'promise-polyfill/src/polyfill';
import 'unfetch/polyfill';
import 'abortcontroller-polyfill';

import Vue from 'vue';
import VueRouter from 'vue-router';
import Cookies from 'js-cookie';
import { v4 as uuid } from 'uuid';
import { CoaPlugin } from '@mgo/core';
import { isLocalDev } from '@mgo/core/src/environment';
import ExperiencesPlugin from './plugins/experiences';
import coaPersistPlugin from './plugins/coaPersist';
import App from './App.vue';
import router from './router';
import store from './store';
import getAmpersendKey from './utils/ampersend';
import gtm from './utils/gtm';
import ga from './utils/ga';
import grecaptcha from './utils/grecaptcha';
import segment from './utils/segment';
import './css/index.css';

/*
 * session id for page view and create coa
 * lives for 1 day
 */
if (!Cookies.get('mgo_sid')) {
  Cookies.set('mgo_sid', uuid(), {
    expires: 1,
    sameSite: 'Strict',
    secure: !isLocalDev(window.location.origin),
  });
}

gtm();
segment();
ga();

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(coaPersistPlugin);
Vue.use(CoaPlugin, {
  api: '',
  origin: 'MGO',
  coaUUID: Cookies.get('coa') || '',
  orderId: Cookies.get('coaOrderId') ? parseInt(Cookies.get('coaOrderId'), 10) : null,
  postbackURL: `${window.location.origin}/action`,
  sid: Cookies.get('mgo_sid'),
});
Vue.use(ExperiencesPlugin, {
  key: getAmpersendKey(),
  logLevel: process.env.NODE_ENV !== 'production' ? 'error' : 'info',
  persist: false,
});

new Vue({
  router,
  store,
  async created() {
    const config = await this.$coa.configGet();
    if (config?.rapidKeyUrl) {
      this.$store.set('config', config);
    }
    grecaptcha(config?.recaptchaEnabled || false);
    this.$store.commit('mfa/SET_COA', this.$coa);
    window.addEventListener('message', (event) => {
      if (event.origin !== window.location.origin) {
        return;
      }
      window.profiling_complete(event, () => this.$store.commit('mfa/DISABLE_PROFILING'));
    }, false);
  },
  render: (h) => h(App),
}).$mount('#app');
